module.exports = __webpack_public_path__ + "static/web-1-36a6bbb3fc48a8f91a7d67226ad989e3.mp4";